import axios, { type AxiosError } from 'axios';
import { env } from '@/lib/env';
import { tokenStorage } from '@/lib/auth/tokenStorage';

export const http = axios.create({
  baseURL: env.VITE_API_BASE_URL || undefined, // empty → đường dẫn tương đối, ăn theo Vite proxy
  timeout: 15_000,
});

http.interceptors.request.use((config) => {
  const token = tokenStorage.get();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

http.interceptors.response.use(
  (res) => res,
  (err: AxiosError<{ error?: { code: string; message: string } }>) => {
    if (err.response?.status === 401) {
      // Lazy require để tránh vòng lặp import giữa http <-> store
      import('@/store/sessionStore').then(({ sessionStore }) => {
        sessionStore.getState().logout(/* skipRedirect */ false);
      });
    }
    return Promise.reject(err);
  },
);

/**
 * Lấy error code & message chuẩn từ response của BE: `{ error: { code, message } }`.
 */
export function extractApiError(err: unknown): { code: string; message: string } {
  const ax = err as AxiosError<{ error?: { code: string; message: string } }>;
  const data = ax?.response?.data;
  if (data?.error?.code) {
    return { code: data.error.code, message: data.error.message };
  }
  return { code: 'INTERNAL', message: ax?.message ?? 'Có lỗi xảy ra' };
}
